import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>As individuals, our personalities are made up of an infinite
                                                combination of these scales. However,
                                                it can be useful to look at where we fall on each scale, how
                                                that might impact on our decision
                                                making style and which areas we might not characteristically
                                                consider.</p>
                                            <p>The ‘Big 5’ personality factors have been shown over many
                                                years of research to be directly
                                                relevant to the workplace. A recent meta-study<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>4</sup></a>&nbsp; examining
                                                the results of many studies into these
                                                personality factors found positive relationships between
                                                factors such as conscientousness and
                                                openness to experience and work performance and job
                                                satisfaction.</p>

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">EFFECTIVELY MAKING JUDGEMENT CALLS</span>
                                            </div>
                                            <p>The information above provided an overview of how awareness
                                                of your personality can help you
                                                to further develop your decision making style and therefore
                                                feel more confident in the decisions
                                                you make. This exercise will help you to identify your
                                                personality profile, information you might
                                                often fail to consider (‘blind spots’) and show you how you
                                                can use a broader approach for
                                                decision making in future. Use the worksheet to complete
                                                this exercise.</p>

                                            <div className="border_subtitle">Step one</div>
                                            <p>Using the personality questions below, identify which aspect
                                                of each personality trait you identify with most.</p>
                                            <div className="border_subtitle">Step two</div>
                                            <p>Read through the information on decision making style to make
                                                your choices. If there are any
                                                scales that you feel don’t fully reflect your style, that’s
                                                OK – make a note of them on the worksheet.</p>
                                            <div className="border_subtitle">Personality questions</div>
                                            <p>For each scale below, choose which of the 2 descriptions is
                                                most like you:</p>


                                            <div className="lightgreencontentbg keyquestionpad">


                                                <ol className="testclass_numeric"
                                                    style={{counterReset: 'item'}}>
                                                    <li><p className="further_info_content"><span
                                                        className="green"><strong>Extraversion</strong></span>
                                                    </p></li>
                                                </ol>
                                                <p className="further_info_content pad-sept"><span
                                                    className="pad-bot">Are you more</span></p>

                                                <p><span className="green"
                                                         style={{paddingRight: '12px'}}><strong>a)</strong> </span> Outgoing,
                                                    gregarious, needing lots of social interaction and
                                                    stimulation? </p>

                                                <div style={{paddingBottom: '13px'}}><span
                                                    className="subtiltereg1">OR</span></div>
                                                <div className="uiheading">
                                                    <p><span className="green"
                                                             style={{paddingRight: '10px'}}><strong>b)</strong> </span> Quiet,
                                                        reflective, with a preference for spending more time
                                                        on your own?</p>


                                                </div>
                                            </div>
                                            <p><span className="subtiltereg">Extraversion decision making style</span>
                                            </p>
                                            <p>a) You may prefer a decision making style that gets ideas,
                                                information and energy from other
                                                people. You may instinctively involve stake holders in the
                                                decision making to solicit opinion and
                                                get others on board. You will feel confident with your
                                                decision because you have gathered lots of
                                                opinions. This may mean, however, that you can tend to rely
                                                on others to help you in making
                                                decisions and you may find it more difficult to be confident
                                                in making decisions by yourself.</p>
                                            <p>b) You may prefer a decision making style that allows you to
                                                reflect on the information you have,
                                                on your own. When you need to involve others you are likely
                                                to do so with one other or a small
                                                group. The benefit of this can be diverse information and
                                                candid opinions. You may, however,
                                                risk not consulting with others and therefore missing
                                                important information with which to make
                                                your decision.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}